export default __webpack_public_path__ + "static/media/us_3.381fb1e0.mp3";